import React, { HTMLProps } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'src/store';
import cn from 'classnames';
import DepositionItemFileName from '../DepositionItemFileName';
import { FileData } from 'src/dataFactory/depositionFactory';
import './styles.scss';
import { Text, View } from 'src/components/common';

const DepositionItemListFileName: React.FC<Props> = ({ title, type, files, isLocked = false, className, ...props }) => {
  return (
    <View className={cn('cmp-depo-item-list-file-name', className)} {...props}>
      <Text className="cmp-depo-item-list-file-name__title" size={14}>
        {title}
        {files.length > 0 && ` (${files.length})`}
      </Text>
      {files.length === 0 && (
        <Text size={14} className="cmp-depo-item-list-file-name__na">
          N/A
        </Text>
      )}
      {files.length !== 0 && (
        <ul className="cmp-depo-item-list-file-name__list">
          {files.map((file, index) =>
            index < 2 ? (
              <li
                className="deposition-item-list-file-name__list-item"
                key={`deposition-item-list-file-name-${type}-${index}`}>
                <DepositionItemFileName file={file} />
              </li>
            ) : null,
          )}
          {files.length > 2 && (
            <li className="cmp-depo-item-list-file-name__list-item">
              <Text className="cmp-depo-item-list-file-name__file-more" size={14}>{`+${files.length - 2} more`}</Text>
            </li>
          )}
        </ul>
      )}
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLDivElement> & {
    type: 'exhibit' | 'final' | 'production';
    files: FileData[];
    title: string;
    isLocked?: boolean;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionItemListFileName);
